import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { CategoryListComponent } from './category-list.component';
import { DialogComponent } from './dialog/dialog.component';
import { RoleGuard } from '../../../_guards/role.guard';

const routes: Routes = [
    {
        path     : 'categorylist',
        component: CategoryListComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        CategoryListComponent,
        DialogComponent
    ],
    entryComponents: [DialogComponent],
    providers:[
        AuthGuard,RoleGuard
    ]
})
export class CategoryListModule
{
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/category-list/category-list.module.ts